import { conversations as actions } from '../actions'

export const reducer = {}

reducer[actions.UPDATE_CONVERSATIONS] = ({ state, action }) =>
  action.payload(state)

reducer[actions.SET_SELECTED_THREAD] = ({ state, action: { payload } }) => ({
  ...state,
  selectedThread: payload
})
